import { useEffect, useState } from "react";

export function usePath(): [string, (to: string) => void] {
  const [path, setPath] = useState<string>(() => window.location.pathname || "/");

  useEffect(() => {
    const onPopState = () => {
      setPath(window.location.pathname || "/");
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const navigate = (to: string) => {
    if (window.location.pathname !== to) {
      window.history.pushState(null, "", to);
      setPath(to);
      window.scrollTo(0, 0);
    }
  };

  return [path, navigate];
}
